import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";

import { useGetItemDetailsResult } from "./types/itemDetails.types";
import { useCatalogicalGetSoftwareDetails } from "./useCatalogicalGetSoftwareDetails";
import { useGetHardwareDetails } from "./useGetHardwareDetails";

export const useGetItemDetailsFactory = (taxonomyId: ItemTaxonomyId): (() => useGetItemDetailsResult) => {
  const domain: string = taxonomyId.dataDomain ?? "";
  switch (domain) {
    case "amznham":
      return useGetHardwareDetails;

    case "software":
      return useCatalogicalGetSoftwareDetails;
    default:
      return useCatalogicalGetSoftwareDetails;
  }
};
